(function () {
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function closedDay(v, allowSat) {
    if (!v) return false;
    var p = v.split('-'); var d = new Date(+p[0], +p[1] - 1, +p[2]).getDay();
    return d === 0 || (d === 6 && !allowSat);
  }
  var wanted = '';
  try { wanted = new URLSearchParams(window.location.search).get('tjanst') || ''; } catch (e) {}
  document.querySelectorAll('form.bv-form').forEach(function (form) {
    if (form.dataset.bvInit) return; form.dataset.bvInit = '1';
    var date = form.querySelector('[data-bv-date]');
    var service = form.querySelector('[data-bv-service]');
    var err = form.querySelector('[data-bv-error]');
    var allowSat = date && date.dataset.saturday === 'true';
    if (date) {
      var min = new Date(); min.setDate(min.getDate() + 1);
      var max = new Date(); max.setDate(max.getDate() + (parseInt(date.dataset.days, 10) || 60));
      date.min = iso(min); date.max = iso(max);
      date.addEventListener('change', function () { date.setCustomValidity(closedDay(date.value, allowSat) ? 'Vi har stängt den dagen – välj en annan dag.' : ''); });
    }
    // Förval via ?tjanst= – bara om värdet finns i listan
    if (service && wanted) {
      for (var i = 0; i < service.options.length; i++) if (service.options[i].value === wanted) { service.selectedIndex = i; break; }
    }
    form.addEventListener('submit', function (e) {
      if (date) date.setCustomValidity(closedDay(date.value, allowSat) ? 'Vi har stängt den dagen – välj en annan dag.' : '');
      if (!form.checkValidity()) {
        e.preventDefault();
        var first = form.querySelector(':invalid');
        if (err) { err.textContent = 'Fyll i alla obligatoriska fält (*). ' + (first && first.validationMessage ? first.validationMessage : ''); err.hidden = false; }
        if (first) first.focus();
      }
    });
  });
})();
